import {Injectable} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {env} from './env';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import {NotificationsService} from './notifications.service';
import {Constraint} from '../model/constraint';
import {ItemConstraint} from '../model/item-constraint';
import {catchError} from 'rxjs/operators';
import {ItemConstraintRequest} from '../model/Item-constraint-request';
import {ItemConstraintType} from '../model/ItemConstraintType';
import {GeographicArea} from '../model/geographic-area';
import {Tiers} from '../model/tiers';
import {CsvExportPricesConstraint} from "../model/csv-export-prices-constraint";
import {CsvExportPricesRequest} from "../model/csv-export-prices-request";


@Injectable({
  providedIn: 'root'
})
export class ManageConstraintService {

  private url= env.apiUrl + '/v3/item_constraint';
  private urlUtils = env.apiUrl + '/v1';
  constructor(private http: HttpClient,
              private notificationsService: NotificationsService) {}


  addConstraint(constraint: Constraint) {

    return this.http.post(this.url, constraint);
  }

  getItemConstraints(pageSize: number, pageNumber: number, itemConstraintType: string, itemId: number, itemCode: number, userId: string): Observable<ItemConstraint[]> {
    var url = this.url +
      '/all' +
      '?page_size=' + pageSize +
      '&page_number=' + pageNumber;

    url = this.updateUrlWithParam(false, url, itemConstraintType, itemId, itemCode, userId);
    return this.http
      .get<ItemConstraint[]>(url)
      .pipe(catchError(e => this.handleError(e)));
  }

  getCounts(itemConstraintType : string, itemId : number, itemCode: number, userId: string): Observable<number> {
    var url = this.url +
      '/count';

    url = this.updateUrlWithParam(true, url, itemConstraintType, itemId, itemCode, userId);

    return this.http.get<number>(url)
      .pipe(catchError(e => this.handleError(e)));
  }

  updateUrlWithParam(isCount: boolean, url : string, itemConstraintType: string, itemId: number, itemCode: number, userId: string){
    const params: string[] = [];

    if (itemConstraintType) params.push(`item_constraint_type=${itemConstraintType}`);
    if (itemId) params.push(`item_id=${itemId}`);
    if (itemCode) params.push(`item_code=${itemCode}`);
    if (userId) params.push(`user_id=${userId}`);

    return params.length > 0 ? `${url}${isCount ? '?' : '&'}${params.join('&')}` : url;
  }

  deleteItemConstraint(itemConstraintId : number): Observable<void> {
    const url = this.url +
      '/' + itemConstraintId;

    return this.http.delete<void>(url)
      .pipe(catchError(e => this.handleError(e)));
  }

  closeItemConstraint(itemConstraintId : number, itemConstraintRequest: ItemConstraintRequest): Observable<void> {
    const url = this.url +
      '/' + itemConstraintId;

    return this.http.patch<void>(url, itemConstraintRequest);
  }

  getConstraintType(): Observable<ItemConstraintType []> {
    const url = this.urlUtils +
      '/item_constraint_type'
    return this.http.get<ItemConstraintType []>(url);
  }

  getGeographicAreaByTiers(tiersList : Tiers []): Observable<GeographicArea []> {
    const tiersRequest: {} = {
      tiers : tiersList
    };
    const url : string = this.urlUtils +
      '/geographic_tiers';
    return this.http.post<GeographicArea []>(url, tiersRequest);
}

  exportItemConstraintByPeriod(csvExportPricesRequest : CsvExportPricesRequest): Observable<CsvExportPricesConstraint []> {
    var url : string = this.url +
      '/export';
    return this.http
      .post<CsvExportPricesConstraint[]>(url, csvExportPricesRequest);
  }

  handleError(error: HttpErrorResponse)  {
    console.error(`Backend returned code ${error.status}, body was: ${JSON.stringify(error)}`);
    this.notificationsService.error('Something wrong happened...', `Backend returned code ${error.status}`);
    return EMPTY;
  }

}

